import { useAuth } from 'src/shared/hooks/use-auth';

export const getMemberDetails = (memberId: string) => {
  const authData = useAuth.getState().userDetails;
  const currentOrganisationId = authData?.memberInformation?.organisation?.organisationId;

  const currentOrganisation = authData?.organisations?.find(
    (org) => org.organisationId === currentOrganisationId
  );

  if (currentOrganisation?.members) {
    const member = currentOrganisation?.members?.find(
      (member) => member.memberId === memberId || member._id === memberId
    );

    if (member) {
      return member;
    }
  }
  return {};
};

export const getAllOrgMembers = () => {
  const authData = useAuth.getState().userDetails;
  const currentOrganisationId = authData?.memberInformation?.organisation?.organisationId;

  const currentOrganisation = authData?.organisations?.find(
    (org) => org.organisationId === currentOrganisationId
  );

  if (currentOrganisation?.members) {
    return currentOrganisation?.members;
  }
  return [];
};
